<template>
  <div>
    <div class="form-check form-check-inline" style="text-align: left;">
      <input
        type="radio"
        name="flexRadioDefault"
        id="flexRadioDefault1"
        v-model="isBonus"
        :value="true"
        @click="updateBonus(true)"
        class="form-check-input"
      />
      <label for="flexRadioDefault1" class="form-check-label">
        เลือกรับโบนัส
      </label>
    </div>
    <div class="form-check form-check-inline" style="text-align: left;">
      <input
        type="radio"
        name="flexRadioDefault"
        id="flexRadioDefault2"
        @click="updateBonus(false)"
        v-model="isBonus"
        :value="false"
        class="form-check-input"
      />
      <label for="flexRadioDefault2" class="form-check-label">
        เลือกไม่รับโบนัส
      </label>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters, mapState } from "vuex";
import { UserInfoMixins } from "@/mixins/UserInfo.js";
import { PrefixMixins } from "@/mixins/Prefix.js";
import { BankMixins } from "@/mixins/BankService.js";
import { updateBonus } from "@/services/modules/promotion.js";

export default {
  name: "UpdateBonus",
  mixins: [UserInfoMixins, PrefixMixins, BankMixins],

  data() {
    return {
      isBonus: false,
    };
  },
  computed: {
    ...mapGetters([
      "getError",
      "getLoading",
      "getLineId",
      "getGameList",
      "getPromotion",
      "getPrefix",
    ]),
  },

  watch: {
    UserInfo(newValue, oldValue) {
      console.log("UserInfo");
      console.log(newValue.BonusInfo);
      this.isBonus = newValue.BonusInfo.isBonus;
    },
  },
  methods: {
    ...mapActions(["checkAuth", "userSignOut"]),
    async reload() {
      await this.checkAuth();
    },
    async updateBonus(status) {
      await updateBonus(this.$swal, status, async (res) => {
        if (res.status) {
          await this.reload();

          console.log(status);
          this.isBonus = status;
          this.$swal.fire("อัพเดทสภานะโปรโมชั่นเรียบร้อยแล้ว", "", "success");
        } else {
          this.isBonus = !status;
        }
      });
    },
  },
  async mounted() {},
};
</script>



// WEBPACK FOOTER //
// src/components/form/UpdateBonus.vue